<template>
  <v-card>
    <v-card-title>
      <v-text-field
        v-model="newGroupName"
        :label="$t('Users.GroupManager.newGroup')"
        type="text"
        @keyup.enter="createGroup"
      >
        <template v-slot:append>
          <v-btn icon @click="createGroup" :disabled="!newGroupName">
            <v-icon color="primary">add_box</v-icon>
          </v-btn>
        </template>
      </v-text-field>
    </v-card-title>
    <v-card-text>
      <v-list>
        <v-list-item v-for="group in sortedGroups" :key="'group' + group.id" >
          <v-list-item-action>
            <v-icon>groups</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            {{group.name}}
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click.stop="deleteGroup(group.id)" color="secondary">
              <v-icon>delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import FileMixin from '@/mixins/FileMixin'
import { UserGroupRepository } from '@portal/api'
export default {
  name: 'UserGroupsManager',
  mixins: [FileMixin],
  data: () => ({
    newGroupName: '',
    groups: [],
  }),
  computed: {
    sortedGroups () {
      return [...this.groups].sort((groupA, groupB) => groupA.name.toLowerCase() > groupB.name.toLowerCase() ? 1 : -1)
    }
  },
  methods: {
    async createGroup() {
      try {
        const newGroup = await UserGroupRepository.create({name: this.newGroupName})
        this.groups.push(newGroup)
        this.newGroupName = ''
        this.$store.dispatch('notify/success', this.$t('Message.Success.create'))
      } catch (error) {
        this.$store.dispatch('notify/error', this.$t('Message.Error.create'))
      }
    },
    async deleteGroup(id) {
      try {
        await UserGroupRepository.delete(id)
      } catch (error) {
        this.$store.dispatch('notify/error', this.$t('Message.Error.delete'))
      }
      const index = this.groups.findIndex(group => group.id === id)
      if (this.selectedGroup && this.selectedGroup.id === id) this.selectedGroupIndex = null
      this.groups.splice(index, 1)
    }
  },
  async created () {
    this.groups = await UserGroupRepository.fetchAll()
  }
}
</script>